import React from "react";
import DatePicker from "react-datepicker";
import './Dateinput.scss';

const DateInput = (props) => {
  // const datePickerRef = createRef();

  // const handleOnKeyDown = event => {
  //   if (datePickerRef?.current && !datePickerRef.current.state.open) {
  //     if (event?.keyCode === 13 || event?.which === 13) {
  //       event.preventDefault();
  //       datePickerRef.current?.setOpen(true);
  //     }
  //   }
  // };

  return (
    <DatePicker
      selected={props.selected}
      name={props.name}
      onChange={props.onChange}
      // className={props.className}
      className={props.data? `${props.className} disabled`:`${props.className} active`}
      placeholderText="DD-MMM-YYYY"
      dateFormat="dd-MMM-yyyy"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      value={props.value}
      fixedHeight
      readOnly={props.data?props.data:props.readOnly}
      // preventOpenOnFocus={true}
      // ref={datePickerRef}
      // onKeyDown={handleOnKeyDown}
    />
  );
};

export default DateInput;